// Air Gap-protected Media endpoints. Lives in shared/ because the
// canonical PhotoGalleryPanel needs it without crossing the
// shared/→features/ boundary. inventoryApi.js re-exports for
// backward compat with existing feature-side callers.

import { apiFetch } from '../../auth/apiFetch';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:7071/api';

export async function getMedia(toolId, callerEmail = null) {
  const params = new URLSearchParams({ tool_id: toolId });
  if (callerEmail) params.append('caller_email', callerEmail);
  const res = await apiFetch(`${API_BASE_URL}/get_media?${params}`);
  if (!res.ok) throw new Error(`get_media failed: ${res.status}`);
  return res.json();
}

export async function deleteMedia(mediaId, callerEmail) {
  const params = new URLSearchParams({ media_id: mediaId });
  if (callerEmail) params.append('caller_email', callerEmail);
  const res = await apiFetch(`${API_BASE_URL}/delete_media?${params}`, { method: 'DELETE' });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `delete_media failed: ${res.status}`);
  }
  return res.json();
}
